import { Button } from '@components/button';
import { ExternalLink } from '@components/link';
import { Typography } from '@components/typography';
import { Box, Stack, useTheme } from '@mui/material';
import { navigate } from 'gatsby';

type CookiesSettingsModalProps = {
  onClose?: () => void;
  handleAcceptCookie?: () => void;
};

export const CookiesSettingsModal = ({
  onClose,
  handleAcceptCookie,
}: CookiesSettingsModalProps) => {
  const { palette } = useTheme();

  const handleAcceptButton = () => {
    handleAcceptCookie();
    onClose();
  };

  const handleRejectButton = () => {
    navigate('/sign-in');
  };

  return (
    <Stack maxWidth="927px" data-cy="Cookies-Settings-Modal" gap={6}>
      <Box
        py={9}
        px={5}
        overflow="auto"
        height="100%"
        sx={{ backgroundColor: palette.background.default }}
      >
        <Typography variant="subtitle2" data-cy="Cookies-Settings-Modal-Tab-Panel-Rendered">
          We and selected third parties may use cookies for technical purposes and, with your
          consent, for other purposes as specified in our privacy policy. Denying consent will
          render our service unavailable. You can consent to the use of cookies by selecting the
          “Accept all” button, or you can close this window, which will sign you out of the
          application. <br /> <br /> On our website, cookie information is not typically used to
          directly identify you, but use of cookies allows us to provide required web experience
          personalization and enables website capability.
          <br /> <br /> Information we collect is subject to our{' '}
          <ExternalLink href="https://rendered.ai/privacy-policy/">Privacy Policy</ExternalLink>
        </Typography>
      </Box>
      <Box width="100%" display="flex" justifyContent="center" alignItems="center">
        <Box pr={10}>
          <Button
            data-cy="Cookies-Settings-Modal-SideTab-Accept-All-Button"
            onClick={handleAcceptButton}
            autoFocus
          >
            Accept all
          </Button>
        </Box>
        <Button
          variant="secondary"
          data-cy="Cookies-Settings-Modal-SideTab-Reject-Button"
          onClick={handleRejectButton}
        >
          Reject
        </Button>
      </Box>
    </Stack>
  );
};
